function hasText(value) {
  return typeof value === 'string' && value.trim().length > 0;
}

/** SOAP / narrative placeholders that should not appear in the progress note body. */
export function isProgressNotePlaceholder(value) {
  const text = String(value || '').trim();
  if (!text) return true;
  return /^not\s+documented\.?$/i.test(text)
    || /^غير\s*موثق\.?$/i.test(text)
    || /^—$|^-$|^n\/?a$/i.test(text);
}

/** Free-text body for progress notes (replaces SOAP UI). */
export function getProgressNoteBody(note) {
  if (!note) return '';
  // Return narrative exactly as stored so typing (spaces, newlines) is not rewritten.
  if (typeof note.narrative === 'string' && note.narrative.length > 0) {
    return note.narrative;
  }

  const soap = note.soap || {};
  const fromSoap = ['subjective', 'objective', 'assessment', 'plan']
    .map((key) => String(soap[key] || '').trim())
    .filter((value) => value && !isProgressNotePlaceholder(value))
    .join('\n\n');
  if (fromSoap) return fromSoap;
  return typeof note.narrative === 'string' ? note.narrative : '';
}

export function setProgressNoteBody(note, text) {
  const value = typeof text === 'string' ? text : '';
  return {
    ...note,
    narrative: value,
    soap: {
      subjective: value,
      objective: '',
      assessment: '',
      plan: '',
    },
  };
}

export function progressNoteHasContent(note) {
  return hasText(getProgressNoteBody(note));
}
